import useBrazilianIssuer from "components/company/v3/context/hooks/useBrazilianIssuer";
import { FormattedMessage } from "react-intl";

export default function BrazilianCompanyExternalLinks() {
  const { investorRelationsUrl, website, cvmCode, tickerSymbolPrefix } = useBrazilianIssuer();

  return (
    <div className="flex items-center divide-x divide-gray-200 *:px-2 first:*:pl-0 last:*:pr-0">
      {website && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={website}
          className="px-2 text-sm font-medium text-blue-600 hover:underline"
        >
          <span>
            <FormattedMessage defaultMessage="Website" id="JkLHGw" />
          </span>
        </a>
      )}

      {investorRelationsUrl && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={investorRelationsUrl}
          className="px-2 text-sm font-medium text-blue-600 hover:underline"
        >
          <span>
            <FormattedMessage defaultMessage="Site de RI" id="LSwTIE" />
          </span>
        </a>
      )}

      {cvmCode && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`https://sistemaswebb3-listados.b3.com.br/listedCompaniesPage/main/${cvmCode}/${tickerSymbolPrefix}/overview?language=pt-br`}
          className="px-2 text-sm font-medium text-blue-600 hover:underline"
        >
          <span>
            <FormattedMessage defaultMessage="Site B3" id="gq9/A4" />
          </span>
        </a>
      )}
    </div>
  );
}
